import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { header as str } from "$strings";

export default ({ children, floating = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className={"App-header" + (floating ? " floating" : "")}>
      <NavLink to="/" className="Header-title">
        {str.title}
      </NavLink>
      <nav className="burger">
        {!menuOpen && (
          <ul>
            <button onClick={() => setMenuOpen(true)}>
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                preserveAspectRatio="xMidYMid meet"
                viewBox="99.99941176470591 100.00176470588227 100.00000000000003 69.99588235294115"
                width="28px"
                height="28px"
              >
                <defs>
                  <path d="M200 100L100 100" id="a4VjoxGhjs"></path>
                  <path d="M200 135L100 135" id="d7CvKSKJxH"></path>
                  <path d="M200 170L100 170" id="aUe53Y47k"></path>
                  <path d="M200 103L100 103" id="a4VjoxGhjs2"></path>
                  <path d="M200 138L100 138" id="d7CvKSKJxH2"></path>
                  <path d="M200 173L100 173" id="aUe53Y47k2"></path>
                </defs>
                <g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#a4VjoxGhjs"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#000000"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#a4VjoxGhjs2"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#d7CvKSKJxH"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#000000"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#d7CvKSKJxH2"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#aUe53Y47k"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#000000"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                  <g>
                    <g>
                      <use
                        xlinkHref="#aUe53Y47k2"
                        opacity="1"
                        fillOpacity="0"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeOpacity="1"
                      ></use>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </ul>
        )}
        {menuOpen && (
          <ul className="overlay-menu">
            <button onClick={() => setMenuOpen(false)}>X</button>
            <NavLink to="upload" className="Nav-list-item">
              {str.create_video}
            </NavLink>
            <NavLink to="contact" className="Nav-list-item">
              {str.about}
            </NavLink>
          </ul>
        )}
      </nav>
      <nav className="desktop">
        <ul>
          <NavLink to="upload" className="Nav-list-item">
            {str.create_video}
          </NavLink>
          <NavLink to="contact" className="Nav-list-item">
            {str.about}
          </NavLink>
        </ul>
      </nav>
    </header>
  );
};
